import { useCallback, useEffect, useRef, useState } from 'react';
import ComboBox from '../Input/ComboBox';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function SelectObjectDepartment({
    label = 'department',
    valueSelect = null,
    getValue = (e) => e,
    sizeCbb = 'medium',
    disabled = false,
}) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [value, setValue] = useState([]);
    const getRef = useRef(false);
    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 500);
    }, []);
    useEffect(() => {
        setValue(valueSelect);
    }, [valueSelect]);

    const handleOnchangeValue = (e) => {
        setValue(e);
        getValue(e);
    };
    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [1];
        sendRequest(serviceList.getAlldepartment, InVal, getDataResult, true, timeOutFunctDepartment, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            setData(data);
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        getRef.current = false;
    };
    return (
        <ComboBox
            label={t(label)}
            valueSelect={valueSelect}
            displayLabel="departs_nm"
            valueEqual="id"
            getValue={handleOnchangeValue}
            selectOption={data}
            sizeCbb={sizeCbb}
            disabled={disabled}
        />
    );
}

export default SelectObjectDepartment;
